/**
 * Marketplace – L'Marketplace workspace labels
 * Used in profile, team modals when project type is Marketplace
 */

export default {};
